import { 
	LinkAuthError, 
	LinkAuthException 
} from 'phoenix/domain';

export class LinkAuthExceptionFactory{
    public static $inject = [
        'gettextCatalog'
    ];

    constructor(public gettextCatalog:ng.gettext.gettextCatalog){}

    public create(errorCode:LinkAuthError){
        return new LinkAuthException(
            this.gettextCatalog,
            errorCode
        );
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/factories/link-auth-exception-factory.ts